const paymentProviderLogoBasePath = "/assets/img/logos/payment-providers/";
const PaymentProviderLogoEnum = {
    0: "parkfolio-logo.png", 
    1: "parkonomy-logo.png",
    2: "ringo-logo.png", 
    3: "flowbird-logo.png", 
    4: "justpark-logo.png", 
    5: "tap2park-logo.png", 
    6: "paybyphone-logo.svg",
    7: "parkbunny-logo.png",
    8: "ips-logo.svg",
    9: "convious-logo.svg",
    10: "lookingforcarpark-logo.svg",
    11: "newpark-logo.png",
    12: "parkso-logo.svg",
    13: "my-car-pass-logo.svg"
}

const pcnPaymentProviderLogoBasePath = "/assets/img/logos/pcn-payment-providers/";
const PcnPaymentProviderLogoEnum = {
    0: "stripe.png", 
    2: "bacs.svg", 
}

export default {
    fetchPaymentProviderLogo(paymentProviderLogoEnumIndex) {
        return <img width="100%" src={`${paymentProviderLogoBasePath}${PaymentProviderLogoEnum[paymentProviderLogoEnumIndex]}`} />
    },

    fetchPcnPaymentProviderLogo(pcnPaymentProviderLogoEnumIndex) {
        return <img width="100%" src={`${pcnPaymentProviderLogoBasePath}${PcnPaymentProviderLogoEnum[pcnPaymentProviderLogoEnumIndex]}`} />
    },
}